{
  "name": "backbone.marionette",
  "description": "The Backbone Framework",
  "version": "3.0.0-rc1",
  "homepage": "https://github.com/marionettejs/backbone.marionette",
  "main": "lib/core/backbone.marionette.js",
  "keywords": [
    "backbone",
    "plugin",
    "marionette",
    "composite",
    "architecture",
    "single",
    "page",
    "app",
    "client",
    "browser"
  ],
  "license": "MIT",
  "scripts": {
    "build": "gulp build",
    "coverage": "gulp coverage",
    "coveralls": "gulp coveralls",
    "test": "gulp"
  },
  "author": {
    "name": "Derick Bailey",
    "email": "derickbailey@gmail.com",
    "url": "http://derickbailey.com/"
  },
  "bugs": {
    "url": "https://github.com/marionettejs/backbone.marionette/issues"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/marionettejs/backbone.marionette.git"
  },
  "github": "https://github.com/marionettejs/backbone.marionette",
  "dependencies": {
    "backbone.babysitter": "^0.1.0",
    "backbone.radio": "^1.0.0",
    "backbone": "1.2.1 - 1.2.3",
    "underscore": "1.8 - 1.8.3"
  },
  "devDependencies": {
    "babel-core": "^6.4.5",
    "babel-eslint": "^4.1.7",
    "babel-preset-es2015": "^6.3.13",
    "babel-preset-es2015-rollup": "^1.1.1",
    "babel-register": "^6.4.3",
    "babelify": "^7.2.0",
    "browserify": "^13.0.0",
    "chai": "^3.4.0",
    "chai-jq": "0.0.9",
    "dox": "git://github.com/jasonLaster/dox.git#marked",
    "glob": "^7.0.0",
    "gulp": "^3.9.0",
    "gulp-coveralls": "^0.1.4",
    "gulp-eslint": "^2.0.0",
    "gulp-file": "^0.2.0",
    "gulp-filter": "^3.0.1",
    "gulp-header": "^1.7.1",
    "gulp-istanbul": "^0.10.2",
    "gulp-jscs": "^3.0.2",
    "gulp-lintspaces": "^0.4.1",
    "gulp-livereload": "^3.8.1",
    "gulp-mocha": "^2.1.3",
    "gulp-plumber": "^1.0.1",
    "gulp-preprocess": "^2.0.0",
    "gulp-rename": "^1.2.2",
    "gulp-sourcemaps": "^1.6.0",
    "gulp-tap": "^0.1.3",
    "gulp-uglify": "^1.4.2",
    "gulp-unwrapper": "^0.1.0",
    "gulp-util": "^3.0.7",
    "gulp-yaml-validate": "^1.0.2",
    "isparta": "^4.0.0",
    "jquery": "^2.1.4",
    "jsdom": "^8.0.2",
    "rollup": "^0.25.2",
    "rollup-plugin-babel": "^2.3.9",
    "rollup-plugin-json": "^2.0.0",
    "sinon": "^1.17.2",
    "sinon-chai": "^2.8.0",
    "vinyl-buffer": "^1.0.0",
    "vinyl-source-stream": "^1.1.0"
  }
}
